import React, { useEffect, useState } from "react";
import DefaultLayout from "../../layouts/defaultLayout";
import "./style.css";

import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL } from "../../constants";
import { Loader } from "rsuite";
import { addition } from "../../assets/svgIcons";
import Modal from "../../components/modal";
import { Input } from "../../components/form-elements";
import { userData } from "../../data/fake_login_data";
import { perms } from "../../data/side_nav_data";
import { exportToCSV } from "../../functions";
import PageHeader from "../../components/page-header";
import StatsCards from "../../components/stats-cards";
import ShowHideModal from "../../components/show-hide-modal";
const ChainsCoursesChapters = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchHeaderKet, setSearchHeaderKey] = useState('');
  const [data, setData] = useState(false);
  const [showAdd, setShowAdd] = useState(false);
  const [chapterName, setChapterName] = useState(false);
  const [chapterLogo, setChapterLogo] = useState(false);
  const [loading, setLoading] = useState(false);
  const [showActions, setShowActions] = useState(false);
  const [filteredData, setFilteredData] = useState(false);
  const [deleteId, setDeleteId] = useState(false);
  const [editId, setEditId] = useState(false);
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.post(
        BASE_URL + "courses/chapters/select_course_chapters.php",
        {
          course_id: location?.state?.course_id,
          admin_id: userData?.user_id,
          access_token: userData?.access_token,
        }
      );
      setData(response?.data?.message);
    } catch (err) {
      setData([]);
      toast.error(err?.message);
    }
  };
  const addChapter = async (e) => {
    e.preventDefault();
    setLoading(true);
    const form = e.target;
    const formData = new FormData();
    formData.append("image", chapterLogo?.files[0]);
    try {
      const imageUpload = await axios.post(
        BASE_URL + "item_img_uploader.php",
        formData
      );
      if (imageUpload?.data?.status == "success") {
        const response = await axios.post(
          BASE_URL + "courses/chapters/insert_chapter.php",
          {
            chapter_title: chapterName?.value,
            chapter_photo: imageUpload?.data?.message,
            course_id: location?.state?.course_id,
            admin_id: userData?.user_id,
            access_token: userData?.access_token,
          }
        );

        if (response.data?.status == "success") {
          toast.success(response.data?.message);
          fetchData();
          setChapterLogo(null);
          setChapterName(null);
          setShowAdd(false);
          form.reset();
          setLoading(false);
        } else {
          setLoading(false);
          toast.error(response.data?.message);
        }
      } else {
        setChapterLogo(false);
        toast.error("Failed on Upload Image");
        setLoading(false);
      }
      // setShowAdd(false);
    } catch (err) {
      toast.error(err?.message);
      setLoading(false);
    }
  };
  const editChapter = async (e) => {
    e.preventDefault();
    setLoading(true);
    const form = e.target;
    const formData = new FormData();
    formData.append("image", chapterLogo);
    try {
      const imageUpload = await axios.post(
        BASE_URL + "item_img_uploader.php",
        formData
      );
      if (
        imageUpload?.data?.status == "success" ||
        !chapterLogo ||
        editId?.chapter_photo
      ) {
        const response = await axios.post(
          BASE_URL + "courses/chapters/update_chapter.php",
          {
            chapter_id: editId?.chapter_id,
            course_id: location?.state?.course_id,
            chapter_photo:
              imageUpload?.data?.message &&
                imageUpload?.data?.message?.length &&
                chapterLogo
                ? imageUpload?.data?.message
                : editId?.chapter_photo,
            chapter_title: chapterName ? chapterName : editId?.chapter_title,
            admin_id: userData?.user_id,
            access_token: userData?.access_token,
          }
        );
        if (response.data?.status == "success") {
          fetchData();
          setEditId(false);
          setChapterLogo(null);
          setChapterName(null);
          form.reset();
          setLoading(false);
          toast.success(response.data?.message);
        } else {
          setLoading(false);
          toast.error(response.data?.message);
        }
      } else {
        setChapterLogo(false);
        toast.error("Failed on Upload Image");
        setLoading(false);
      }
      // setShowAdd(false);
    } catch (err) {
      toast.error(err?.message);
      setLoading(false);
    }
  };
  const handleDeleteChapter = () => {
    const data_send = {
      chapter_id: deleteId?.chapter_id,
      admin_id: userData?.user_id,
      access_token: userData?.access_token,
      hidden: deleteId?.hidden == "no" ? "yes" : "no",
    };
    axios
      .post(
        BASE_URL + "courses/chapters/show_hide_chapter.php",
        JSON.stringify(data_send)
      )
      .then((res) => {
        if (res.data.status == 'success') {
          toast.success(res.data.message);
          setDeleteId(false);
          fetchData();
        } else if (res.data.status == 'error') {
          toast.error(res.data.message);
        } else {
          toast.error("Something Went Error");
        }
      });
  };
  useEffect(() => {
    if (searchHeaderKet && searchHeaderKet?.length) {
      setFilteredData(
        data?.filter(
          (item) =>
            item?.chapter_id == searchHeaderKet ||
            item?.chapter_title?.includes(searchHeaderKet) ||
            item?.chapter_description?.includes(searchHeaderKet)
        )
      );
    } else {
      setFilteredData(data);
    }
  }, [searchHeaderKet, data]); // Use a Set to keep track of unique items

  if (!location?.state?.course_id) {
    navigate(-1);
  }

  return (
    <div id="home">
      <DefaultLayout
        setSearchHeaderKey={setSearchHeaderKey}
        children={
          <>
            <PageHeader

              title={"Chapters For Course (" + location?.state?.course_name + ")"}
              description="Manage chapter information and settings"
              exportButton={
                perms?.includes("*5_2") || perms?.startsWith("5_2")
                  ? true
                  : false
              }
              deleteButton={
                perms?.includes("*5_2") || perms?.startsWith("5_2")
                  ? true
                  : false
              }
              addButton="Add Chapter"
              data={data}
              setShowAdd={setShowAdd}
              addition={
                perms?.includes("*5_2") || perms?.startsWith("5_2")
                  ? addition
                  : null
              }
            />
            <StatsCards data={data} title="Chapters" icon={addition} />

            <div className="filters_box">
              {/* <div className="orderby"> */}
              {/* <input type="text" id="orderBy" /> */}
              {/* </div> */}
            </div>
            {!data || !filteredData ? (
              <Loader />
            ) : data?.length || filteredData?.length ? (
              <div className="course_Container">
                {filteredData?.map((item) => {
                  return (
                    <div className="chapter-card">
                      <div className="chapter-image-container">
                        <img
                          src={item?.chapter_photo}
                          alt={item?.chapter_title}
                          className="chapter-image"
                          onClick={() =>
                            perms?.includes("*5_1") || perms?.startsWith("5_1")
                              ? navigate("content", {
                                state: {
                                  university_id: location?.state?.university_id,
                                  course_id: location?.state?.course_id,
                                  grade_id: location?.state?.grade_id,
                                  chain_id: location?.state?.chain_id,
                                  chapter_id: item?.chapter_id,
                                  chapter_name: item?.chapter_title,
                                },
                              })
                              : null
                          }
                        />
                        <div className="chapter-overlay">
                          <div className="chapter-status">
                            <span className={`status-badge ${item?.hidden === "no" ? "active" : "inactive"}`}>
                              {item?.hidden === "no" ? "Active" : "Hidden"}
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="chapter-content">
                        <div className="chapter-header">
                          <h3
                            className="chapter-title"
                            onClick={() =>
                              perms?.includes("*5_1") || perms?.startsWith("5_1")
                                ? navigate("content", {
                                  state: {
                                    university_id: location?.state?.university_id,
                                    grade_id: location?.state?.grade_id,
                                    course_id: location?.state?.course_id,
                                    chain_id: location?.state?.chain_id,
                                    chapter_id: item?.chapter_id,
                                    chapter_name: item?.chapter_title,
                                  },
                                })
                                : null
                            }
                          >
                            {item?.chapter_title}
                          </h3>
                          <div className="chapter-actions">
                            <button
                              className="action-toggle"
                              onClick={() => {
                                setShowActions(
                                  showActions !== item?.chapter_id
                                    ? item?.chapter_id
                                    : false
                                );
                              }}
                            >
                              <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                                <circle cx="12" cy="6" r="2" />
                                <circle cx="12" cy="12" r="2" />
                                <circle cx="12" cy="18" r="2" />
                              </svg>
                            </button>
                            {item?.chapter_id == showActions && (
                              <div className="chapter-actions-menu">
                                {perms?.includes("*5_3") || perms?.startsWith("5_3") ? (
                                  <button
                                    className="action-btn edit-btn"
                                    onClick={() => {
                                      setEditId(item);
                                      setShowActions(false);
                                    }}
                                  >
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                      <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
                                    </svg>
                                    Edit Chapter
                                  </button>
                                ) : null}

                                {perms?.includes("*5_4") || perms?.startsWith("5_4") ? (
                                  <button
                                    className="action-btn toggle-btn"
                                    onClick={() => {
                                      setDeleteId(item);
                                      setShowActions(false);
                                    }}
                                  >
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                                    </svg>
                                    {item?.hidden == "no" ? "Hide Chapter" : "Show Chapter"}
                                  </button>
                                ) : null}

                                {perms?.includes("*5_6") || perms?.startsWith("5_6") ? (
                                  <button
                                    className="action-btn subscription-btn"
                                    onClick={() => {
                                      navigate("subscriptions", {
                                        state: {
                                          university_id: location?.state?.university_id,
                                          course_id: location?.state?.course_id,
                                          chain_id: location?.state?.chain_id,
                                          chapter_id: item?.chapter_id,
                                          chapter_name: item?.chapter_title,
                                        },
                                      });
                                      setShowActions(false);
                                    }}
                                  >
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                                    </svg>
                                    Subscriptions
                                  </button>
                                ) : null}

                                {perms?.includes("*5_7") || perms?.startsWith("5_7") ? (
                                  <button
                                    className="action-btn quiz-btn"
                                    onClick={() => {
                                      navigate("/chains/courses/quizzes", {
                                        state: {
                                          university_id: location?.state?.university_id,
                                          course_id: location?.state?.course_id,
                                          chain_id: location?.state?.chain_id,
                                          chapter_id: item?.chapter_id,
                                          chapter_name: item?.chapter_title,
                                        },
                                      });
                                      setShowActions(false);
                                    }}
                                  >
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                      <path d="M9 11H7v6h2v-6zm4 0h-2v6h2v-6zm4 0h-2v6h2v-6zm2.5-9H19V1h-2v1H7V1H5v1H4.5C3.67 2 3 2.67 3 3.5v15c0 .83.67 1.5 1.5 1.5h15c.83 0 1.5-.67 1.5-1.5v-15c0-.83-.67-1.5-1.5-1.5zM19 18.5H5v-12h14v12z" />
                                    </svg>
                                    Quizzes
                                  </button>
                                ) : null}

                                {perms?.includes("*5_8") || perms?.startsWith("5_8") ? (
                                  <button
                                    className="action-btn notification-btn"
                                    onClick={() => {
                                      navigate("chapnots", {
                                        data: item,
                                        ...{
                                          university_id: location?.state?.university_id,
                                          course_id: location?.state?.course_id,
                                          chain_id: location?.state?.chain_id,
                                          chapter_id: item?.chapter_id,
                                          chapter_name: item?.chapter_title,
                                        },
                                      });
                                      setShowActions(false);
                                    }}
                                  >
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                      <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z" />
                                    </svg>
                                    Notifications
                                  </button>
                                ) : null}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="chapter-footer">
                          <div className="chapter-category">
                            <span className="category-badge">Chapter</span>
                          </div>
                          {perms?.includes("*5_5") || perms?.startsWith("5_5") ? (
                            <button
                              className="auto-subscription-btn"
                              onClick={() =>
                                navigate("chanpphonelist", {
                                  state: {
                                    chain_id: location?.state?.chain_id,
                                    university_id: location?.state?.university_id,
                                    grade_id: location?.state?.grade_id,
                                    course_id: location?.state?.course_id,
                                    chapter_id: item?.chapter_id,
                                  },
                                })
                              }
                            >
                              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z" />
                              </svg>
                              Auto Subscription
                            </button>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <h4>No Chapters</h4>
            )}
          </>
        }
      />
      <Modal
        headerTitle={"Add Chapter"}
        open={showAdd}
        toggle={setShowAdd}
        children={
          <form
            action="#"
            onSubmit={!loading ? addChapter : (e) => e.preventDefault()}
          >
            <div className="inputField">
              <label htmlFor="chapter_name">Chapter Name</label>
              <Input
                type={"text"}
                id={"chapter_name"}
                name={"chapter_name"}
                onChange={setChapterName}
              />
            </div>
            <div className="inputField">
              <label htmlFor="chapter_Logo">Chapter Logo</label>
              <Input
                type={"file"}
                id={"chapter_Logo"}
                name={"chapter_Logo"}
                onChange={setChapterLogo}
                showImage={true}
              />
            </div>

            <div className="modal-button-container">
              <button className="modal-btn modal-btn-primary">
                {loading ? (
                  <div className="button-loading">
                    <div className="spinner"></div>
                    <span>Saving...</span>
                  </div>
                ) : (
                  <div className="button-content">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z" />
                    </svg>
                    <span>Save Chapter</span>
                  </div>
                )}
              </button>
            </div>
          </form>
        }
      />
      <Modal
        headerTitle={"Edit Chapter"}
        open={editId}
        toggle={setEditId}
        children={
          <form
            action="#"
            onSubmit={!loading ? editChapter : (e) => e.preventDefault()}
          >
            <div className="inputField">
              <label htmlFor="chapter_title">Chapter Name</label>
              <Input
                type={"text"}
                id={"chapter_title"}
                name={"chapter_title"}
                defaultValue={editId?.chapter_title}
                onChange={(e) => setChapterName(e.value)}
              />
            </div>

            <div className="inputField">
              <label htmlFor="chapter_Logo">Chapter Logo</label>
              <Input
                type={"file"}
                id={"chapter_Logo"}
                name={"chapter_Logo"}
                onChange={(e) => setChapterLogo(e.files[0])}
                showImage={true}
              />
            </div>

            <div className="modal-button-container">
              <button className="modal-btn modal-btn-primary">
                {loading ? (
                  <div className="button-loading">
                    <div className="spinner"></div>
                    <span>Saving...</span>
                  </div>
                ) : (
                  <div className="button-content">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z" />
                    </svg>
                    <span>Save Chapter</span>
                  </div>
                )}
              </button>
            </div>
          </form>
        }
      />
      <Modal
        open={deleteId}
        toggle={setDeleteId}
        headerTitle={"Show / Hide - Chapter"}
        children={
          <ShowHideModal
            hiddenId={deleteId}
            setHiddenId={setDeleteId}
            hidden={deleteId?.status === "yes" ? true : false}
            loading={loading}
            setLoading={setLoading}
            hideUniv={handleDeleteChapter}
            title="Chapter"
          />
        }
      />
    </div>
  );
};

export default ChainsCoursesChapters;
